import { useEffect, useState } from "react";

import { deleteAttributes } from "../../../api/attributes";
import { restoreAttributes } from "../../../api/trash";

export const useTrashAttributes = (attributes) => {
  const [attributesPicked, setAttributesPicked] = useState([]);
  const [selectedAllAttributes, setSelectedAllAttributes] = useState(false);

  const handlePickedAttribute = (attribute) => {
    setAttributesPicked((prev) => {
      if (prev.includes(attribute.id)) {
        return prev.filter((id) => id !== attribute.id);
      }
      return [...prev, attribute.id];
    });
  };

  const handlePickedAllAttributes = () => {
    if (selectedAllAttributes) {
      setAttributesPicked([]);
    } else {
      setAttributesPicked(attributes.map((attribute) => attribute.id));
    }
  };

  const handleRestoreAttributes = async (onSuccess, onError) => {
    if (attributesPicked.length) {
      await restoreAttributes({ attributeIds: attributesPicked }, onSuccess, onError);
    }

    setAttributesPicked([]);
    setSelectedAllAttributes(false);
  };

  const handleDeleteAttributes = async () => {
    if (attributesPicked.length) {
      await deleteAttributes({ attributeIds: attributesPicked });
    }

    setAttributesPicked([]);
    setSelectedAllAttributes(false);
  };

  useEffect(() => {
    if (attributesPicked?.length === attributes?.length && attributes?.length > 0) {
      setSelectedAllAttributes(true);
    } else {
      setSelectedAllAttributes(false);
    }
  }, [attributesPicked]);

  return {
    attributesPicked,
    selectedAllAttributes,

    handlePickedAttribute,
    handlePickedAllAttributes,
    handleRestoreAttributes,
    handleDeleteAttributes,
  };
};
